module.exports = __webpack_public_path__ + "static/img/shanghaipu1.5efc042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shanghaipu1.png
// module id = 7E2/
// module chunks = 1